<template>
  <span
    class="border-burgundy-100 bg-burgundy-50 text-burgundy-700"
    :class="[labelBadgeBase, sizeClasses.tag, sizeClasses.segment]"
  >
    <!-- lucide: flask-conical -->
    <svg
      :class="labelBadgeIcon"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path
        d="M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2"
      />
      <path d="M8.5 2h7" />
      <path d="M7 16h10" />
    </svg>
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import {
  labelBadgeBase,
  labelBadgeIcon,
  labelBadgeSize,
  LabelBadgeSize,
} from "@/components/Core/labelBadge";

const props = defineProps({
  size: { type: String as PropType<LabelBadgeSize>, default: "md" },
  label: { type: String, default: "Beta" },
});

const sizeClasses = computed(() => labelBadgeSize[props.size]);
</script>
